// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar-module--sidebar--1zM7S","sidebar__inner":"Sidebar-module--sidebar__inner--2Tprz"};